<template>
  <div> {{ ActDescBtn }}
    <table :height="this.windowSize.height - 8" :max-height="this.windowSize.height - 8" style="position: absolute;"
           width="100%">
      <tr height="48px" max-height="48px">

        <ContenidoBase :EstadoBtn="EstadoBtn" :descripcion="'Consulta General Fact.Electronica'" :titulo="'Consulta General Fact.Electronica'"
                       @MethodAnular="anular" @MethodEliminar="remove" @MethodGuardar="save"
                       @MethodImprimir="imprimirList"
                       @MethodNuevo="newwnuevo" @abrirBarraTablaDinamica="abrirTabla" />
      </tr>
      <tr>

        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn>
                    <v-btn color="deep-purple accent-2" dark small
                           @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitBancos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->

        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <div class="px-2">
              <v-card color="grey lighten-3">

                <div class="px-2 pb-2" style="border: 1px solid #000000">
                  <v-form ref="formFactVenta" v-model="valid" lazy-validation @submit.prevent="">

                    <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
                      <v-row class="pa-0 ma-0 py-0 my-0">


                        <v-col v-if="false" class="pa-0 ma-0 px-2 py-1" cols="12" md="2" sm="2">
                          <v-text-field v-model.number="ConsultaFacturas.numsec" autocomplete="off" dense hide-details
                                        label="No.Factura:" outlined placeholder=" "
                                        style="font-size: 12px;" @blur="getFacVenta" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                            <v-text-field
                              id="fecha-inicial"
                              v-model="ConsultaFacturas.fechaInicial"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Inicial"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurDesde"
                              @input="getFacVenta"
                              v-on:input="resertPaginacion">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                         <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                          <v-text-field
                              v-model="ConsultaFacturas.fechaFinal"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Final"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurHasta"
                              @input="getFacVenta"
                              v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                          <v-text-field v-model="ConsultaFacturas.ncf" autocomplete="off" dense hide-details label="NCF"
                                        outlined style="font-size: 12px;" @blur="getFacVenta">
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>

                          <v-row class="pa-0 ma-0 py-0 my-0" >
                             <v-col style="border: 1px solid #000000;" class="pa-0 ma-0 px-2 py-1 mt-1" cols="12" md="6" sm="6" >
                            <v-radio-group v-model="ConsultaFacturas.opcionActivo" class="pt-0 mt-0 d-flex justify-center " dense  hide-details row @change="changeRadioOpc">
                                  <v-radio :value="true" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">ACTIVO</strong></template>
                                  </v-radio>
                                  <v-radio :value="false" color="red" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">ANULADO</strong></template>
                                  </v-radio>
                            </v-radio-group>
                             </v-col>
                              <v-col class="pa-0 ma-0 px-2 py-1 mt-1" cols="12" md="6" sm="6" >
                              <center v-if="ConsultaFacturas.opcionTipoReg==1" >
                            <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                      <!-- actualizarFacEletronico(DtoFacturaVentas) -->
                                    <v-btn id="actualizar-factura" color="blue" dark outlined
                                          small v-on="on" @click.prevent="enviarTodaFactura()">
                                      <i class="fa fa-plus-square" style="font-size: 20px;"></i> ENVIAR TODAS LAS FACTURA
                                    </v-btn>

                                  </template>
                                  <span>ENVIAR TODAS LAS FACTURA</span>
                                </v-tooltip>
                          </center> 
                             </v-col>

                          </v-row>
                       

                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1 mt-1" cols="12" md="6" sm="6" >
                          <div style="border: 1px solid #000000;">
                            <v-radio-group v-model="ConsultaFacturas.opcionTipoReg" class="pt-0 mt-0 d-flex justify-center " dense  hide-details row @change="changeRadioOpc">
                                  <v-radio :value="1" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">FACTURA</strong></template>
                                  </v-radio>
                                  <v-radio :value="2" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">DEVOLUCIÓN</strong></template>
                                  </v-radio>
                                  <v-radio :value="3" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">NOTA CRÉDITO</strong></template>
                                  </v-radio>
                                  <v-radio :value="4" color="green" label="">
                                   <template v-slot:label><strong style="color: #000000; font-size: 11px">NOTA DÉBITO</strong></template>
                                  </v-radio>

                            </v-radio-group>
                          </div>
                      <!-- <v-row class="pa-0 ma-0 py-0 my-0" ></v-row> -->
                          <center >
                        <!-- class="pa-0 ma-0 py-0 my-0" :class="`d-flex justify-center white--text`"-->
                        <!-- <v-row no-gutters></v-row> -->
                        <span style="font-size: 12px"><b>OPCION FAC. ELECTRÓNICO:</b>
                          <!-- <span style="color: #C62828;"> Para </span> --> </span>
                        <v-radio-group v-model="ConsultaFacturas.opcion" class="pt-0 mt-0 d-flex justify-center " dense
                                       hide-details
                                       row @change="changeRadioOpc">
                          <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                          <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                          <v-radio :value="0" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">TODOS</strong>
                            </template>
                          </v-radio>
                          <v-radio id="no-enviada" :value="1" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">NO ENVIADA</strong>
                            </template>
                          </v-radio>

                          <v-radio :value="2" color="green" label="">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">ENVIADA</strong>
                            </template>
                          </v-radio>


                        </v-radio-group>
                        <v-text-field v-if="ConsultaFacturas.opcion==2" v-model="ConsultaFacturas.buscarTrackId"
                                      autocomplete="off"
                                      class="pt-0 mt-0 fontSize12"
                                      dense hide-details label="" single-line style="border:1px solid #000000;"
                                      @blur="getFacVenta">
                          <template v-slot:prepend-inner>
                            <i class="fa fa-search" style="font-size: 20px;"></i>
                          </template>
                          <template v-slot:label>
                            <!-- <strong style="color: #000000; font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</strong> -->
                            <span style="font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</span>
                          </template>
                        </v-text-field>
                         </center>           
                        </v-col>

                      </v-row>
                    </v-col>
                  </v-form>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                      <div style="border: 1px solid #000000">
                      <!-- @click:row="datostabla" -->
                  
                      <v-lazy  v-model="isActive" :options="{  threshold: .5 }" min-height="500"  transition="fade-transition">
                      <v-data-table
                          v-if="resertPagi == true"
                          id="facturas-table"
                          v-model="selected"
                          :footer-props="getArrayPropiedases(arrayPropiedases)"
                          :headers="[
                            { text: 'Referencia', sortable: false, value: 'refregistro', width: 120 , class: ['no-gutters black--text'] },
                          { text: 'Fecha Emision', sortable: false, value: 'fechaEmision', width: 150 , class: ['no-gutters black--text'] },
                          { text: 'eNCF', sortable: false, value: 'encf', width: 200,class: ['no-gutters black--text'] },
                          // { text: 'Comprador', sortable: false, value: 'comprador', width: 129, class: ['no-gutters black--text'] },
                          { text: 'Código Seguridad', sortable: false, value: 'codSeguridad', width: 129, class: ['no-gutters black--text'] },
                          { text: 'Monto Total', sortable: false, value: 'montoTotal', width: 129, class: ['no-gutters black--text'] },
                          { text: 'Estado', sortable: false, value: 'estado', width: 150, class: ['no-gutters black--text'] },
                          { text: 'Activo/Anulado', sortable: false, value: 'activoanulado', width: 80, class: ['no-gutters black--text'] },
                        ]"
                          :items="listFactVent"
                          :items-per-page="paginator.itemsPerPage"
                          :search="search"
                          :server-items-length="TotalRegistros"
                          :show-select="true"
                          :single-select="true"
                          class="elevation-1 RowSelectColor TbSize13"
                          dense
                          item-key="indx"
                          @pagination="cargarPaginacion"
                          @item-selected="obtenerDatoSelect"
                          @click:row="datostabla"
                      >
                        <template v-slot:item.action="{ item }">
                          <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                          <!-- <v-btn color="red darken-3" fab x-small @click.prevent="deleFact(item)">
                            <i class="fa fa-trash-o" style="font-size: 20px"></i>
                          </v-btn> -->
                        </template>

                        <template v-slot:item.fechaEmision="props">
                          <span style="font-size: 13px; display: none">
                            {{ (props.item.indx = `${listFactVent.indexOf(props.item)}-${props.item.refregistro}`) }}
                          </span>
                          <span style="font-size: 13px">{{ props.item.fechafirmadgii}}</span>
                        <!-- FormatoFecha(props.item.fecha) -->
                        </template>

                        <template v-slot:item.encf="props">
                          <span style="font-size: 13px">{{ props.item.ncf}}</span>
                        </template>

                        <!-- <template v-slot:item.comprador="props">
                          <span style="font-size: 13px">
                           {{ props.item.contenidoJson.encabezado.comprador==null?"CONTADO":props.item.contenidoJson.encabezado.comprador.rncComprador}}
                          </span>
                        </template> -->

                        <template v-slot:item.codSeguridad="props">
                          <!-- <span style="font-size: 13px">{{props.item.contenidoJson.encabezado.codigoSeguridadeCF!=null?props.item.contenidoJson.encabezado.codigoSeguridadeCF:'N/A'}}</span> -->
                       <!-- {{getCodSeguridad(props.item)}} -->
                        <span style="font-size: 13px">{{ props.item.signatureValue}}</span>
                        </template>

                        <template v-slot:item.montoTotal="props">
                          <span style="font-size: 13px">{{ currencyFormatter(props.item.valor)}}</span>
                        </template>
                        
                        <template v-slot:item.estado="props">
                          <span style="font-size: 13px"> <b :class="claseColorEstado(props.item.trackId)">{{ getEstado(props.item.trackId) }}</b>
                            
                          </span>
                        </template>

                        <template v-slot:item.activoanulado="props">
                           <span v-if="props.item.activo==true" style="font-size: 13px"> <b class="green--text">ACTIVO</b></span>
                          <span v-if="props.item.activo==false" style="font-size: 13px"> <b class="red--text">ANULADO</b></span>
                        </template>


                        <!-- <template v-slot:item.valor="props">
                          <span style="font-size: 13px">{{ currencyFormatter(props.item.valor) }}</span>
                        </template> -->

                        <!-- <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:11px; color: #00838F;">Total de horas:</strong></td>
         
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(Totales.totalHora)}} </strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
  </tr>
 </template>
<template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>Total de horas:{{currencyFormatter(Totales.totalHora)}} </span>
      

      </v-list-item-content>
    </v-list-item>

  </template> -->
                      </v-data-table>
                    </v-lazy>

                    </div>
                    </v-col>

                </div>
              </v-card>
              <div v-if="puedeVerDesactProc==true" >
              <hr/>
              <v-card color="grey lighten-3">
                <div class="px-2 pt-1" style="border: 1px solid #000000">
                  <v-col v-if="DtoFacturaVentas!=null"  class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
                    <v-card>
                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#BDBDBD;">
                      <span><b>{{getInfProceso(ConsultaFacturas.opcionTipoReg)}}</b></span>
                    </v-col> 

                    <v-row class="py-2" >

                       <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                         <v-text-field id="formdisabledInput" :value="getInfDataProceso(DtoFacturaVentas,'Fecha')" :disabled="true" dense
                                     hide-details label="FECHA:" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        </v-col>

                      <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                         <v-text-field id="formdisabledInput" :value="getInfDataProceso(DtoFacturaVentas,'NoSec')" :disabled="true" dense
                                     hide-details label="No.Factura:" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-slack" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>

                        
                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                         <v-text-field id="formdisabledInput" v-model="DtoFacturaVentas.refregistro" :disabled="true" dense
                                     hide-details label="Referencia:" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-map-signs" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                         <v-text-field id="formdisabledInput" v-model="DtoFacturaVentas.ncf" :disabled="true" dense
                                     hide-details label="NCF" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-barcode" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                            <v-switch
                                v-model="DtoFacturaVentas.activo"
                                class="mt-0"
                                color="success"
                                hide-detail
                                label="ACTIVO">
                              <template v-slot:label>
                                <strong v-if="DtoFacturaVentas.activo == true" style="color: #000000; font-size: 13px">
                                  ACTIVO: Si
                                </strong>
                                <strong v-if="DtoFacturaVentas.activo == false" style="color: #000000; font-size: 13px">
                                  ACTIVO: No
                                </strong>
                              </template>
                            </v-switch>
                        </v-col>
                      <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <!-- actualizarFacEletronico(DtoFacturaVentas) -->
                              <v-btn id="actualizar-Estado" color="success" dark outlined
                                     small v-on="on" @click.prevent="actualizarEstadoProceso(DtoFacturaVentas)">
                                <i class="fa fa-refresh" style="font-size: 20px;"></i> ACTUALIZAR ESTADO
                              </v-btn>

                            </template>
                            <span>ACTUALIZAR ESTADO</span>
                          </v-tooltip>

                      </v-col>


                    </v-row>
                      
                    </v-card>
                  </v-col>
                </div>
              </v-card>
              </div>
              <hr/>

              <v-card color="grey lighten-3">
                <div class="px-2 pt-1" style="border: 1px solid #000000">
                  <!-- Facturacion Electronica -->
                   <!--v-if="activarModuloEletronica(DtoFacturaVentas)==true  -->
                <v-col v-if="DtoFacturaVentas!=null" class="pa-0 ma-0 py-0 my-0"
                       cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
                  <v-card>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="background-color:#BDBDBD;">
                      <span><b>Facturación Electrónica</b></span>
                    </v-col>

                    <!-- cuerpo FACTURACION ELETRONICA -->
                    <v-col cols="12" md="12" sm="12">
                      <v-row>
                        <v-col class="py-0 my-0" cols="12" md="3" sm="3">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <!-- actualizarFacEletronico(DtoFacturaVentas) -->
                              <v-btn id="actualizar-factura" color="blue" dark outlined
                                     small v-on="on" @click.prevent="actualizarFacEletronico(DtoFacturaVentas)">
                                <i class="fa fa-plus-square" style="font-size: 20px;"></i> ACTUALIZAR FACT.ELECTRONICA
                              </v-btn>

                            </template>
                            <span>ACTUALIZAR FACT.ELECTRONICA</span>
                          </v-tooltip>
                        </v-col>

                      <v-col v-if="DtoFacturaVentas!=null && DtoFacturaVentas.trackId!=null && DtoFacturaVentas.trackId.trim().length>0" class="py-0 my-0" cols="12" md="1" sm="1">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">

                               <v-btn  color="green" dark outlined
                                     small v-on="on" @click.prevent="descargarXml()">
                                <i class="fa fa-file-code-o" style="font-size: 20px;"></i>XML
                              </v-btn>


                              <!-- <v-btn color="green"
                                  dark fab x-small
                                  v-on="on" @click.prevent="descargarXml"  >
                                <i class="fa fa-file-code-o" style="font-size: 18px"></i>
                              </v-btn> -->

                            </template>
                            <span>DESCARGAR XML</span>
                          </v-tooltip>
                        </v-col>



                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                         <v-text-field id="formdisabledInput" v-model="DtoFacturaVentas.refregistro" :disabled="true" dense
                                      label="Referencia:" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-map-signs" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                         <v-text-field id="formdisabledInput" v-model="DtoFacturaVentas.ncf" :disabled="true" dense
                                      label="NCF" outlined style="font-size:13px;">
                          <template v-slot:prepend>
                            <i class="fa fa-barcode" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>
                        </v-col>
                        
                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                          <v-text-field id="formdisabledInput" :value="DtoFacturaVentas.signatureValue!=null?DtoFacturaVentas.signatureValue:'N/A'"
                                        autocomplete="off" dense
                                        disabled
                                        hide-details label=" signatureValue:" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-shield" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col class="py-0 my-0" cols="12" md="2" sm="2">
                          <v-text-field id="formdisabledInput" :value="DtoFacturaVentas.fechafirmadgii"
                                        autocomplete="off"
                                        dense disabled
                                        hide-details label="fechafirmadgii" outlined style="font-size:13px;">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 20px;"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="DtoFacturaVentas.qrdgii" auto-grow
                                      autocomplete="off" dense
                                      disabled hide-details label="QR:" outlined
                                      rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-textarea id="formdisabledInput" :value="DtoFacturaVentas.trackId" auto-grow
                                      autocomplete="off" dense
                                      hide-details label="trackId:" outlined rows="1">
                            <template v-slot:prepend>
                              <i class="fa fa-commenting" style="font-size: 20px;"></i>
                            </template>
                          </v-textarea>
                        </v-col>

                        <v-col v-if="false" cols="12" md="6" sm="6">
                        <pre style="font-size: 10px;">
                          AMBIENTE:(testecf/certecf/ecf)
                          CONSULTA:
                          1- https://ecf.dgii.gov.do/{AMBIENTE}/consultaresultado/help/index.html
                          2- https://ecf.dgii.gov.do/{AMBIENTE}/consultaestado/help/index.html
                        </pre>
                        </v-col>


                      </v-row>
                    </v-col>
                    <!-- FINcuerpo FACTURACION ELETRONICA -->

                  </v-card>

                </v-col>
                <!-- fn Facturacion Electronica -->
                </div>
              </v-card>


            </div>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->

        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">
            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog v-model="acti_tb_data" label="myAlert" max-height="100%" max-width="100%" persistent
              transition="fab-transition">
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            ">
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------  Modal Loader -->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          <br></br>
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

     <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsUtilitarioFacturaVentas ref="RefComponentsUtilitarioFacturaVentas"/>
    </div>

    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsUtilitarioDevolucion ref="RefComponentsUtilitarioDevolucion"/>
    </div>
  
    <!-- columna  ---------------------->
    <div class="overflow-x-auto" v-show="false">
                  <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
    </div>

<!---------------------  Panel Menu Opcion Botones ------------------------------->
    <div style="max-height:300px;" class="overflow-x-auto" v-show="false">
      <!-- columna  ---------------------->
      <PvMenuOpcionBotones ref="RefPvMenuOpcionBotones" @DataRetornAccion="DataRetornMenuOpcBotonesPermisosPv"
        @DataRetornAccionPadre="DataRetornPadrePermisoPv" />
    </div>
     <!--------------------- fin Panel Menu Opcion Botones ------------------------------->
    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js"
import BarraBusqueda2 from "../components/BarraBusquedaDinam"
import ContenidoBase from "../components/ContenidoBase"
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter,fechaNueva } from "@/js/Funciones.js"
import { parse } from "@fortawesome/fontawesome-svg-core";
import ComponentsUtilitarioFacturaVentas from "@/Utilitario/UtilitarioFacturaVentas.vue"
import ComponentsUtilitarioDevolucion from "@/Utilitario/UtilitarioDevolucion.vue"
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import PvMenuOpcionBotones from "@/PuntodeVenta/UtilidadComponents/PvMenuOpcionBotones.vue";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ComponentsUtilitarioFacturaVentas,
    ComponentsUtilitarioDevolucion,
    PvDgiiFacturacionEletronica,
    PvMenuOpcionBotones
  },

  created() {
    var json = {
      titulo: "Consulta General Fact.Electronica",
      descripcion: "Consulta General Fact.Electronica",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,
      accion: [
        "ConsultaFacturasNew",
        "ConsultaFacturasSave",
        "ConsultaFacturasRemove",
        "ConsultaFacturasAnular",
        "ConsultaFacturasPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ConsultaFacturasNew", this.new);
    // EventBus.$on("ConsultaFacturasSave", this.save);
    // EventBus.$on("ConsultaFacturasRemove", this.remove);
    // EventBus.$on("ConsultaFacturasAnular", this.remove);
    // EventBus.$on("ConsultaFacturasPrintList", this.imprimirList);
    EventBus.$on("emitConsultaFacturas", this.datostabla)
    EventBus.$on("onResize", this.onResize)


//this.actualzarinfo_factura_dgi(dt)

    this.verificPermisoFactElectDesactProc()
    this.getFacVenta()
  },

  data: () => ({
    puedeVerDesactProc:false,
    isActive:false,
    arrayPropiedases: {
      "items-per-page-options": [10, 15, 20, 50],
      "items-per-page-text": "Cantidad de Registros Por Paginas",
      showFirstLastPage: false,
    },
    listDatos: [],
    selectedListFact: [],
    selected: [],
    RDocumento: [],
    RSucursal: [],
    listFactVent:[],
    windowSize: { width: "auto", height: "auto" },
    texAria: "",
    rowDesTab: 25,
    Reparaloading: false,
    DtoFacturaVentas:null,
    TotalRegistros: 1,
    resertPagi: true,
    paginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },
    ConsultaFacturas: {
      ncf: null,
      opcion:0,
      numsec: null,
      buscarTrackId:"",
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      opcionTipoReg:1,
      opcionActivo:true
      //fechaCreacion: new,
      //  fechaModificacion: "", 
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" },
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    aalert: {
      estado: false,
      color: null,
    },

    debounceTimer: null,
  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter, FormatoFecha, HoraFormatter, getParamFecha,fechaNueva,
    onResize(e) {
      //this.windowSize=e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

    },

    // datostabla(e) {
    //   this.ConsultaFacturas = e
    //   this.acti_tb_data = false
    // },

    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    newwnuevo() {
      (this.ConsultaFacturas = {
            ncf: null,
            opcion:0,
            numsec: null,
            buscarTrackId:"",
            fechaInicial: fechaNueva(),
            fechaFinal: fechaNueva(),
            opcionTipoReg:1,
            opcionActivo:true
      }),
        EventBus.$emit("actualizaBarraBusqueda2")
    },

 resertPaginacion() {
      this.resertPagi = false

      this.paginator.page = 1
      this.paginator.pageStart = 0
      this.paginator.pageStop = this.paginator.itemsPerPage

      var _this = this
      setTimeout(function () {
        _this.resertPagi = true
      }, 500)

      //setTimeout(this.resertPagi=true,1500);
    },

    cargarPaginacion(e) {
      this.selected = []
      // console.log('cargarPaginacion')
      //     console.log(e);
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
        // this.paginator.itemsPerPage.push(15)
      }

      this.getFacVenta()
      //   this.filtro();
    },



getFacVenta() {
      // if(this.ConsultaFacturas.NoFactura.length==0){this.ConsultaFacturas.NoFactura=0}

      if (
          (this.ConsultaFacturas.numsec != null && this.ConsultaFacturas.numsec.length == 0) ||
          this.ConsultaFacturas.numsec == 0
      ) {
        this.ConsultaFacturas.numsec = null
      }
      if (this.ConsultaFacturas.ncf != null && this.ConsultaFacturas.ncf.length == 0) {
        this.ConsultaFacturas.ncf = null
      }

      if (this.$refs.formFactVenta.validate()) {
 
        var obj = JSON.parse(JSON.stringify(this.ConsultaFacturas))
        // if (this.ConsultaFacturas.documento != null) {
        //   obj.documento = this.ConsultaFacturas.documento.codigo
        // }
        // if (this.ConsultaFacturas.cliente != null) {
        //   obj.cliente = this.ConsultaFacturas.cliente.codigo
        // }
        obj.limit = this.paginator.itemsPerPage
        obj.ultimo = this.paginator.pageStart

        EventBus.$emit("loading", true)
        this.$axios.post(this.$hostname + this.$hName + "/ConsultaRapida/ConsultaGeneralFactEletronica", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              EventBus.$emit("loading", false)
              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listFactVent = res.data.ListFactura)
            })
            .catch((error) => {
              EventBus.$emit("loading", false)
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },


    GetDataFact(e) {
      this.listDatos = []
      this.listDatos = e
    },

    obtenerDatoSelectFact(e) {
      this.obtenerDatoSelectFactClickRow(e.item)
    },

    obtenerDatoSelectFactClickRow(e) {
      console.log("obtenerDatoSelectFactClickRow")

      this.DtoFacturaVentas=JSON.parse(JSON.stringify(e));

     /* var obj = JSON.parse(JSON.stringify(e))
      obj.horaFactura = new Date(e.horaFactura)
      this.texAria = ""

      if (e.fecha != null) {
        var fecnac = this.getParamFecha(e.fecha)
        obj.fecha = fecnac.split("T")[0]
      }

      this.selectedListFact = []
      this.selectedListFact.push(e)

      this.$axios
        .post(this.$hostname + this.$hName + "/ConsultaRapida/GetFacturas", obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.texAria = res.data, this.ver(res.data)
          console.log("obtenerDatoSelectFactClickRow-->", res.data)

        })
        .catch(error => {
        })*/
    },


    obtenerDatoSelect(e) {
      this.datostabla(e.item)
    },

    datostabla(e) {

if(this.selected.length>0 && this.selected[0].indx===e.indx){

   this.selected= []
   this.DtoFacturaVentas=null
  return
}

      var eftc = JSON.parse(JSON.stringify(e))

      this.selected = []
      this.selected.push(JSON.parse(JSON.stringify(e)))
      this.DtoFacturaVentas=JSON.parse(JSON.stringify(e))
    },

    ver(e) {
      var au = e.split("\n").length
      this.rowDesTab = (au + 2)
    },

    getEstado(e){
      var ESTADO="N/A"
      if(e!=null && e.includes('estado')&&  typeof JSON.parse(e) ==="object"){
      ESTADO=JSON.parse(e).estado
      }
      return ESTADO
    },


     claseColorEstado(e){
      var COLOR=" blue--text "
      //Aceptado: green--text  ,Rechazado: red--text ,Reenviado: orange--text ,N/A: blue--text 
      if(e!=null && e.includes('estado')&& typeof JSON.parse(e) ==="object"){
        var ESTADO=JSON.parse(e).estado
        if(ESTADO.includes('Aceptado')){ COLOR=" green--text "}
        if(ESTADO.includes('Rechazado')){ COLOR=" red--text "}
        // if(ESTADO.includes('Reenviado')){ COLOR=" orange--text "}
      }else{
        COLOR=" blue--text "
      }
      return COLOR
    },


    getCodSeguridad(e){
    //<span style="font-size: 13px">{{props.item.contenidoJson.encabezado.codigoSeguridadeCF!=null?props.item.contenidoJson.encabezado.codigoSeguridadeCF:'N/A'}}</span>
    var   COD_SEG="N/A"

    if(e.contenidoJson.encabezado.codigoSeguridadeCF!=null){
      COD_SEG=e.contenidoJson.encabezado.codigoSeguridadeCF
    }else{
      if(e.qr!=null && e.qr.includes("codigoseguridad")){
        COD_SEG=e.qr.split("codigoseguridad=")[1]
       }
    }

    return COD_SEG;
    },

    activarModuloEletronica(FAC) {

      var BOOL_ACTIVA = false
      var activaSucursal = (FAC.hasOwnProperty("sucursal") && FAC.sucursal != null && FAC.sucursal.facturacionEletronica == true)
      if (FAC != null && FAC.hasOwnProperty("facturasventaPK") && FAC.facturasventaPK.secuencia > 0 && activaSucursal == true) {
        BOOL_ACTIVA = true
      }
      return BOOL_ACTIVA

    },


async enviarTodaFactura(){
  this.contEnviarTodaFactura(this.listFactVent)
},


async contEnviarTodaFactura(DATALIST){

EventBus.$emit("loading", true) 

  if(DATALIST.length>0){
var TIPO_ECF_ARRYS=['E31','E32','E45','E44','E33','E34','E43','E46','E47']

 var LIST_FAC= DATALIST.filter((ee) => ee.activo==true && ee.tiporegistro.trim() === "factura" && TIPO_ECF_ARRYS.some(tipo => ee.hasOwnProperty('ncf') && ee.ncf!=null && ee.ncf.startsWith(tipo)) && ee.factura.trackId ==null || ee.factura.trackId !=null  &&  !ee.factura.trackId.includes("estado"))
    if(LIST_FAC.length==0){
      this.alerta("En esta lista No hay facturas para enviar!", "error");
      return 
    }
    
var ListtrackId=[]
await Promise.all(LIST_FAC.map(async (element) => {
      if(element.tiporegistro==="factura"){
       var resObjCompleto = await this.$refs.RefComponentsUtilitarioFacturaVentas.facturacionEletronicaGet(element.factura)       
        // trackId= resObjCompleto.objtrackId!=null?JSON.stringify(resObjCompleto.objtrackId).toUpperCase():"";    
        ListtrackId.push(resObjCompleto)
      }

}))

var _this = this

setTimeout(function() {
              _this.alerta(` PROCESO EJECUTADO CORRECTAMENTE !!! `, "bien")
              _this.getFacVenta()
              EventBus.$emit("loading", false)
            // return true;
            }, 500)

  }else{
     this.alerta("En esta lista No hay facturas para enviar!", "error");
     EventBus.$emit("loading", false)
     //return false;
  }


},



    async actualizarFacEletronico(FAC) {

if(FAC.activo==false){
 this.alerta(`ESTE REGISTRO ESTA ANULADO... (Revise) !!!.`, "error");
 return;
 }

        //32,31,45,44,34,41,43,33
      var TIPO_ECF_ARRYS=['E31','E32','E45','E44','E33','E34','E43','E46','E47']
    const ncf = FAC.ncf.trim().toUpperCase();
    const esECF = TIPO_ECF_ARRYS.some(tipo => ncf.startsWith(tipo));
      if (!esECF) {
        this.alerta(`EL TIPO DE NCF: ${ncf} NO ES E-CF (Revise) !!!.`, "error");
        return;
      }

    
      // var FACT= JSON.parse(JSON.stringify(FAC.contenidoJson))
      if (FAC.hasOwnProperty("trackId") && FAC.trackId != null && FAC.trackId.trim().length > 0 && FAC.trackId.toUpperCase().includes("ACEPTADO")) {
        this.alerta("ESTA FACTURA YA FUE ACEPTADO(Revise) !!!.", "error")
        return
      }

       if (FAC.hasOwnProperty("trackId") && FAC.trackId != null && FAC.trackId.trim().length > 0 && FAC.trackId.toUpperCase().includes("RECHAZADO")) {
        this.alerta("ESTA FACTURA YA FUE RECHAZADA(Revise) !!!.", "error")
        return
      }

      var trackId=""
     
      if(FAC.tiporegistro==="factura"){
        if(FAC.factura.cedularncncf==null){FAC.factura.cedularncncf='' }
       var resObjCompleto = await this.$refs.RefComponentsUtilitarioFacturaVentas.facturacionEletronicaGet(FAC.factura)       
         trackId= resObjCompleto.objtrackId!=null?JSON.stringify(resObjCompleto.objtrackId).toUpperCase():"";    
      }

      if(FAC.tiporegistro==="devolucion"){
        var objData=null;
        if(FAC.devolucion.hasOwnProperty('facturasventa') && FAC.devolucion.facturasventa!=null){objData= FAC.devolucion.facturasventa}
        if(!objData.hasOwnProperty('trackId') || objData.hasOwnProperty('trackId') && objData.trackId==null || objData.trackId!=null && !objData.trackId.includes("estado")){
          this.alerta(`NOTA: La factura: ${objData.ncf!=null?objData.ncf.trim():" "} de esta 'DEVOLUCION' no ha sido emitida en el proceso eletronico. (REVISE)`, "error")
          return
         }

        var resObjCompleto = await this.$refs.RefComponentsUtilitarioDevolucion.DevolucionEletronicaGetNoImprecion(FAC.devolucion)
         trackId= resObjCompleto.objtrackId!=null?JSON.stringify(resObjCompleto.objtrackId).toUpperCase():"";
      }

      if(FAC.tiporegistro==="notacredito"){
        var objData=null;
        
        if(FAC.notacreditocliente.hasOwnProperty('facturasventa') && FAC.notacreditocliente.facturasventa!=null){objData= FAC.notacreditocliente.facturasventa}
        if(FAC.notacreditocliente.hasOwnProperty('notacreditoclientes') && FAC.notacreditocliente.notacreditoclientes!=null){ objData= FAC.notacreditocliente.notacreditoclientes}

          if(!objData.hasOwnProperty('trackId') || objData.hasOwnProperty('trackId') && objData.trackId==null || objData.trackId!=null && !objData.trackId.includes("estado")){
          this.alerta(`NOTA: La factura: ${objData.ncf!=null?objData.ncf.trim():" "} de esta 'NOTA CREDITO' no ha sido emitida en el proceso eletronico. (REVISE)`, "error")
          return
         }

      if(objData.hasOwnProperty('trackId') &&  objData.trackId!=null && objData.trackId.includes("Rechazado")){
          this.alerta("NOTA: La factura de esta 'NOTA CREDITO' fue RECHAZADO en el proceso eletronico. (REVISE)", "error")
          return
        }

        if(objData.hasOwnProperty('trackId') && objData.trackId!=null && objData.trackId.includes("Aceptado")){ 
         var resObjCompleto = await this.factEletNOTA_CR_Get(FAC.notacreditocliente)
          trackId= resObjCompleto.objtrackId!=null?JSON.stringify(resObjCompleto.objtrackId).toUpperCase():"";
        }

        //notacreditocliente
      }



//notadebito -->notadebitocliente
   if(FAC.tiporegistro==="notadebito"){
        var objData=null; 
        if(FAC.notadebitocliente.hasOwnProperty('facturasventa') && FAC.notadebitocliente.facturasventa!=null){ objData= FAC.notadebitocliente.facturasventa}

         if(!objData.hasOwnProperty('trackId') || objData.hasOwnProperty('trackId') && objData.trackId==null || objData.trackId!=null && !objData.trackId.includes("estado")){
          this.alerta(`NOTA: La factura: ${objData.ncf!=null?objData.ncf.trim():" "} de esta 'NOTA DEBITO' no ha sido emitida en el proceso eletronico. (REVISE)`, "error")
          return
         }

      if(objData.hasOwnProperty('trackId') &&  objData.trackId!=null && objData.trackId.includes("Rechazado")){
          this.alerta("NOTA: La factura de esta 'NOTA DEBITO' fue RECHAZADO en el proceso eletronico. (REVISE)", "error")
          return
        }

        if(objData.hasOwnProperty('trackId') && objData.trackId!=null && objData.trackId.includes("Aceptado")){ 
         var resObjCompleto = await this.factEletNOTA_ND_Get(FAC.notadebitocliente)
          trackId= resObjCompleto.objtrackId!=null?JSON.stringify(resObjCompleto.objtrackId).toUpperCase():"";
        }

        //notacreditocliente
      }
      
  

  
        if (trackId.toUpperCase().includes("ACEPTADO")) {
       this.alerta(`${FAC.tiporegistro.toUpperCase()} EMITIDA CORRECTAMENTE !!! `, "bien")
       }

       if (trackId.toUpperCase().includes("RECHAZADO")) {
        this.alerta(`${FAC.tiporegistro.toUpperCase()} NO FUE EMITIDA CORRECTAMENTE !!! `, "error")
        }

       if (!trackId.toUpperCase().includes("ESTADO")) {
        this.alerta(`${FAC.tiporegistro.toUpperCase()} NO FUE EMITIDA CORRECTAMENTE !!! `, "error")
       }  


      var _this = this
            setTimeout(function() {
              _this.getFacVenta()
              _this.selected = []
              _this.DtoFacturaVentas=null
              //PROCESO FACTURA ELETRONICO PENDIENTE
             }, 600)

     
return
      EventBus.$emit("loading", true) 

    },

async factEletNOTA_CR_Get(NOTCRE){

    var CodigoModificacion=3;
    var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_NOTACREDITO(NOTCRE,CodigoModificacion);

    if (resObjCompleto.objtrackId.estado === "Rechazado") {
        var msj_Error = ""

        Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => {
          msj_Error += ` *- COD:${element.codigo} :${element.valor} \n`
        }))

        this.alerta(msj_Error, "error")
        this.actualizarFAC_ELET_NOTA_CR(NOTCRE , resObjCompleto)
       return resObjCompleto
      }
      this.actualizarFAC_ELET_NOTA_CR( NOTCRE, resObjCompleto)
      return resObjCompleto
    },

    actualizarFAC_ELET_NOTA_CR(FACT, objCompTrackId) {
      var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.notacreditoclientesPK.documento,
        secuencia: FACT.notacreditoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }

      if(FACT.hasOwnProperty('devolucion')&& FACT.devolucion!=null){
        var DEVDATA= FACT.devolucion
        DEVDATA.notacreditoclientes=null
        this.$refs.RefComponentsUtilitarioDevolucion.actualizarDEV_ELETRONICA_NoImprecion(DEVDATA,objCompTrackId)
    }

      this.$axios.post(this.$hostname + this.$hName + "/notacreditocliente/actualizarFactEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          if (objCompTrackId.objtrackId.estado === "Aceptado") {
           //this.alerta("Dato guardado correctamente", "bien")
            
          }

          if (objCompTrackId.objtrackId.estado === "Aceptado Condicional") {
           //this.alerta("Dato guardado correctamente", "bien")
          }


        })
        .catch((error) => {
          console.log("actualizartoken no guardado correctamente-->", error)
        })

    },



async factEletNOTA_ND_Get(NOTDB){

    var CodigoModificacion=3;
    var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_NOTADEBITO_CXC(NOTDB,CodigoModificacion);

    if (resObjCompleto.objtrackId.estado === "Rechazado") {
        var msj_Error = ""

        Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => {
          msj_Error += ` *- COD:${element.codigo} :${element.valor} \n`
        }))

        this.alerta(msj_Error, "error")
      if(!NOTDB.hasOwnProperty('trackId') || NOTDB.hasOwnProperty('trackId') && NOTDB.trackId==null || NOTDB.trackId!=null && !NOTDB.trackId.includes("estado")){ 
          this.actualizarFAC_ELET_NOTA_ND(NOTDB , resObjCompleto)
        }
       return resObjCompleto
      }
      this.actualizarFAC_ELET_NOTA_ND( NOTDB, resObjCompleto)
      return resObjCompleto
    },

    actualizarFAC_ELET_NOTA_ND(FACT, objCompTrackId) {
    var TRACK = objCompTrackId.objtrackId
      //delete TRACK["mensajes"]

      var objTrack = {
        documento: FACT.notadebitoclientesPK.documento,
        secuencia: FACT.notadebitoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii,
        qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue,
        trackId: JSON.stringify(TRACK),
      }


      this.$axios.post(this.$hostname + this.$hName + "/notadebitocliente/actualizarFactEletronica",
        objTrack, { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          if (objCompTrackId.objtrackId.estado === "Aceptado") {
           this.alerta("Dato guardado correctamente", "bien")
            
          }

          if (objCompTrackId.objtrackId.estado === "Aceptado Condicional") {
           this.alerta("Dato guardado correctamente", "bien")
          }

        })
        .catch((error) => {
          console.log("actualizartoken no guardado correctamente-->", error)
        })

    },



 BlurDesde() {
      if (this.ConsultaFacturas.fechaInicial.toString().length == 0) {
        this.ConsultaFacturas.fechaInicial = this.fechaNueva()
      }
    },

    BlurHasta() {
      if (this.ConsultaFacturas.fechaFinal.toString().length == 0) {
        this.ConsultaFacturas.fechaFinal = this.fechaNueva()
      }
    },


getArrayPropiedases(ARRAYSPRO){
 var Sudo = this.$store.getters.GetdatosInfUsu.usuario.sudo
 if(Sudo==true){
   // var ARR_PR=JSON.parse(JSON.stringify(this.arrayPropiedases))
    //  ARR_PR.items-per-page-options=[10, 15, 20, 50,100,250,300,500,800,1000]
  
    var ARR_PR={
    "items-per-page-options": [10, 15, 20, 50,100,250,300,500,800,1000],
      "items-per-page-text": "Cantidad de Registros Por Paginas",
      showFirstLastPage: false,
   }
    return ARR_PR
  }else{
    return ARRAYSPRO;
  }

},
changeRadioOpc(){
this.DtoFacturaVentas=null
this.getFacVenta()
},

getInfProceso(Data){
var inf=""
if(Data==1){ inf='INF. FACTURA'}
if(Data==2){inf='INF. DEVOLUCIÓN'}
if(Data==3){inf='INF. NOTA CRÉDITO'}
if(Data==4){inf='INF. NOTA DÉBITO'}
  return inf;
},

getInfDataProceso(Data,tipo){
  var INF=''
  if(Data.tiporegistro==="factura"){
    if(tipo==="Fecha"){INF=`${this.FormatoFecha(Data.factura.fecha).trim().replaceAll('-', '/')}` }
    if(tipo==="NoSec"){INF=`${Data.factura.facturasventaPK.secuencia}` } 
  }

if(Data.tiporegistro==="devolucion"){
    if(tipo==="Fecha"){INF=`${this.FormatoFecha(Data.devolucion.nuevaFecha).trim().replaceAll('-', '/')}` }
    if(tipo==="NoSec"){INF=`${Data.devolucion.devoclucionPK.secuencia}` } 
  }

  if(Data.tiporegistro==="notacredito"){
    if(tipo==="Fecha"){INF=`${this.FormatoFecha(Data.notacreditocliente.nuevaFecha).trim().replaceAll('-', '/')}` }
    if(tipo==="NoSec"){INF=`${Data.notacreditocliente.notacreditoclientesPK.secuencia}` } 
  }
  
   if(Data.tiporegistro==="notadebito"){
    if(tipo==="Fecha"){INF=`${this.FormatoFecha(Data.notadebitocliente.nuevaFecha).trim().replaceAll('-', '/')}` }
    if(tipo==="NoSec"){INF=`${Data.notadebitocliente.notadebitoclientesPK.secuencia}` } 
  }
  return INF;
},

actualizarEstadoProceso(Data){
 var obj = {
  opcionTipoReg:this.ConsultaFacturas.opcionTipoReg,
  activo:Data.activo
 }

if(Data.tiporegistro==="factura"){
 obj.secuencia= Data.factura.facturasventaPK.secuencia
 obj.documento= Data.factura.facturasventaPK.documento
 obj.operacion= Data.factura.documentoFactura.operacion.codigo
  }

if(Data.tiporegistro==="devolucion"){
  obj.secuencia= Data.devolucion.devoclucionPK.secuencia
  obj.documento= Data.devolucion.devoclucionPK.documento
  obj.operacion= Data.devolucion.documentoinventario.operacion.codigo
  }

  if(Data.tiporegistro==="notacredito"){
     obj.secuencia= Data.notacreditocliente.notacreditoclientesPK.secuencia
     obj.documento= Data.notacreditocliente.notacreditoclientesPK.documento
     obj.operacion= Data.documentocxc.documentocxc.operacion.codigo
  }
  
   if(Data.tiporegistro==="notadebito"){
     obj.secuencia= Data.notadebitocliente.notadebitoclientesPK.secuencia
     obj.documento= Data.notadebitocliente.notadebitoclientesPK.documento
     obj.operacion= Data.documentocxc.documentocxc.operacion.codigo
   }

 EventBus.$emit("loading", true)
        this.$axios.post(this.$hostname + this.$hName + "/ConsultaRapida/actualizarEstadoProceso", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              EventBus.$emit("loading", false)
              this.alerta("Dato Acturalizado(REVISE)", "bien")
              // this.GetDataFact(res.data)
              // ;(this.TotalRegistros = res.data.TbTotalItem), (this.listFactVent = res.data.ListFactura)
            })
            .catch((error) => {
              EventBus.$emit("loading", false)
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
 
//  JSON.parse(JSON.stringify(this.ConsultaFacturas))
},


async verificPermisoFactElectDesactProc(){
  let  BOOL=false
  const reff = this.$refs.RefPvMenuOpcionBotones;
  if (reff) {
      var BOOL_Permiso = await this.$refs.RefPvMenuOpcionBotones.EjecutVerificarPermiso("AccConRapFactElectDesactProc")
      if(BOOL_Permiso===true){
      BOOL=true
      }
  }
this.puedeVerDesactProc = BOOL;
//return BOOL;
},


  DataRetornMenuOpcBotonesPermisosPv(e) {

      },

    DataRetornPadrePermisoPv(e) {

    },

    descargarXml(){

  //var RNCEmisor =FACT.sucursal.rnc.trim().replace("-", "").replace(/-/g,'');
  //var NombreXml=RNCEmisor.trim()+""+DAT.ncf.trim();
  var Dto=this.DtoFacturaVentas
  var NombreXml=""
  var rnc=""
  if(Dto.hasOwnProperty('factura') && Dto.factura!=null && Dto.factura.sucursal!=null){
    rnc=Dto.factura.sucursal.rnc.trim().replace("-", "").replace(/-/g,'')
    NombreXml=rnc+""+Dto.factura.ncf.trim()+"";
  }


if(NombreXml.trim().length>0){
   EventBus.$emit("loading", true)
 this.$axios.get(
    this.$hostname + this.$hName + "/ConsultaRapida/descargar-archivo/"+rnc+"/"+NombreXml,
    { headers: this.$store.getters.GetheadersAxios,
      responseType: "blob"
    })
    .then((response) => {
       EventBus.$emit("loading", false)
    const url = window.URL.createObjectURL(
        new Blob([response.data])
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", NombreXml+".xml");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
})
.catch((error) => {
   EventBus.$emit("loading", false)
    console.error("Error descargando archivo:", error);
});
}




  
    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e)

        this.ejecucion = false
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
    },

    KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },
  },

  computed: {
    ActDescBtn() {
      //console.log('DtoFacturaVentas-->',this.DtoFacturaVentas)
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    },
  },
}
</script>

<style></style>